<template>
    <div class="animated fadeIn lapeks-page">
        <div class="filter-card mb-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <h4 class="page-title mb-0">Laporan Omzet</h4>
                <button type="button" class="btn btn-filter-reset" name="downloadExcelBtn" :disabled="isLoading" @click="confirmCabangDownload()">
                    <i class="fa fa-download mr-2"></i>Download Excel
                </button>
            </div>

            <div class="filter-section">
                <div class="filter-controls-row">
                    <div class="filter-field">
                        <span class="filter-sublabel">Periode</span>
                        <div class="range-group">
                            <b-form-select v-model="input.bulanCabang" id="inputBulanCabang" name="inputBulanCabang" :options="optionBulan" class="filter-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-select v-model="input.tahunCabang" id="inputTahunCabang" name="inputTahunCabang" :options="tahunOption" class="filter-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>
                    </div>

                    <div class="filter-field">
                        <span class="filter-sublabel">Tipe Pinjaman</span>
                        <b-form-select v-model="input.tipePinjamanCabang" name="tipePinjamanCabang" :options="tipePinjamanOption" class="filter-select">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Tipe Pinjaman</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <button type="button" class="btn btn-filter-search" name="searchTableBtn" :disabled="isLoading" @click="onSearch()">
                        <i class="fa fa-search"></i>
                    </button>
                    <button type="button" class="btn btn-filter-reset" name="resetTableBtn" :disabled="isLoading || !showWebCabang" @click="onResetAll()">Reset</button>
                </div>
            </div>
        </div>

        <!--
            ============================================================
            VARIAN "LAPORAN PER BULAN" - dinonaktifkan.
            Referensi hanya menampilkan tabel per-cabang, jadi blok ini
            dimatikan lewat v-if="false" (bukan komentar HTML, karena
            markup di dalamnya memuat "--" yang menutup komentar).
            Kode lama tetap utuh bila nanti mau diaktifkan lagi.
            ============================================================
        -->
        <div v-if="false">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <b-card >
                    <template v-slot:header>
                        <h5>
                            <p class="mb-2">Laporan Omzet per Bulan <span>({{jenisTipeLaporan}}) </span>
                                <span v-if="selectedCabang != null">Cabang {{selectedCabang}}</span>
                                <span v-else>Semua Cabang</span>
                            </p>
                            <h6 class="mb-0">
                                Periode : <span v-if="periodeBulan != '-'">{{ periodeBulan }}</span> <span v-else>Tahun</span> <span>{{ periodeTahun }}</span>
                            </h6>
                        </h5>
                    </template>
                    <b-table show-empty hover
                        :busy="isBusy"
                        :items="showDataOmzet" 
                        :fields="fields" 
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data omzet.
                        </template>
                        <template v-slot:head(kenaikanOmzet)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Omzet 
                        </template>
                        <template v-slot:head(kenaikanOmzetPp)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Omzet Gadai PP 
                        </template>
                        <template v-slot:head(kenaikanTotalOmzet)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Total Omzet
                        </template>
                        <template v-slot:thead-top>
                            <b-tr>
                                <b-th class="custom-subheader-sticky"># </b-th>
                                <b-th colspan="3">Piutang</b-th>
                                <b-th colspan="8">Omzet</b-th>
                                <b-th colspan="7">Pemasukan (Perpanjangan)</b-th>
                                <b-th colspan="8">Pemasukan (Pelunasan)</b-th>
                                <b-th colspan="2">Pemasukan (Gadai)</b-th>
                                <b-th colspan="6">Total Pemasukan
                                    <i class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.click="'Total Pemasukan = Jasa + Admin + Denda + Penalti + Keringanan + Jasa Awal + Admin Awal'"></i>
                                </b-th>
                                <b-th colspan="5">Lelang</b-th>
                            </b-tr>
                        </template>
                        <template v-slot:custom-foot>
                            <td class="custom-footer-sticky"><strong>Total</strong></td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{$helper.addThousandSeparator(showDataOmzetAll.unitOmzet)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.omzet == null">{{$helper.addThousandSeparator(showDataOmzetAll.omzet)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.omzet < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.omzet).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.omzet)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.unitOmzetPp)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.omzetPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.omzetPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.omzetPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.omzetPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.omzetPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalOmzet == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalOmzet < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTransaksiPp)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.bungaPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.bungaPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.bungaPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.bungaPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.bungaPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.dendaPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.dendaPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.dendaPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.dendaPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.dendaPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.penaltiPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.penaltiPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.keringananPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.keringananPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.keringananPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.keringananPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.keringananPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.angsuranPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.angsuranPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp)}} </div>
                            </td>
                            <!-- <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.pokokPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.pokokPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.pokokPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.pokokPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.pokokPp)}} </div>
                            </td> -->
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTransaksiPl)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.bungaPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.bungaPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.bungaPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.bungaPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.bungaPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.dendaPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.dendaPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.dendaPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.dendaPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.dendaPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.penaltiPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.penaltiPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.keringananPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.keringananPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.keringananPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.keringananPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.keringananPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.angsuranPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.angsuranPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.pokokPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.pokokPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.pokokPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.pokokPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.pokokPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.jasaAwal == null">{{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminAwal == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminAwal < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalBunga == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalBunga)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalBunga < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalBunga).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalBunga)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalAdmin == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalAdmin < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalDenda == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalDenda)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalDenda < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalDenda).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalDenda)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalPenalti == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalPenalti < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalKeringanan == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalKeringanan < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalAll == null"><strong>{{$helper.addThousandSeparator(showDataOmzetAll.totalAll)}}</strong> </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalAll < 0"><strong>- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalAll).replace("-", "")}}</strong></div>
                                <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalAll)}} </strong></div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahSetKirim) }}                 
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.modalSetKirim == null">{{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.modalSetKirim < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTerjual) }}                 
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.labaPenjualan == null">{{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.labaPenjualan < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan)}} </div>
                            </td>
                        </template>
                        <template v-slot:cell(cabangName)="row">
                            <div class="no-wrap">
                                <strong>{{ row.item.cabangName }}</strong>
                            </div>
                        </template>
                        <template v-slot:cell(piutangBerjalan)="row">
                            <div class="text-right no-wrap" v-if="row.item.piutangBerjalan == null">{{$helper.addThousandSeparator(row.item.piutangBerjalan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.piutangBerjalan < 0">- Rp{{$helper.addThousandSeparator(row.item.piutangBerjalan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.piutangBerjalan)}} </div>
                        </template>
                        <template v-slot:cell(badDebt)="row">
                            <div class="text-right no-wrap" v-if="row.item.badDebt == null">{{$helper.addThousandSeparator(row.item.badDebt)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.badDebt < 0">- Rp{{$helper.addThousandSeparator(row.item.badDebt).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.badDebt)}} </div>
                        </template>
                        <template v-slot:cell(piutangMacet)="row">
                            <div class="text-right no-wrap" v-if="row.item.piutangMacet == null">{{$helper.addThousandSeparator(row.item.piutangMacet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.piutangMacet < 0">- Rp{{$helper.addThousandSeparator(row.item.piutangMacet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.piutangMacet)}} </div>
                        </template>
                        <template v-slot:cell(omzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.omzet == null">{{$helper.addThousandSeparator(row.item.omzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.omzet < 0">- Rp{{$helper.addThousandSeparator(row.item.omzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.omzet)}} </div>
                        </template>
                        <template v-slot:cell(unitOmzet)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unitOmzet) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(kenaikanOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanOmzet == null">{{$helper.addThousandSeparator(row.item.kenaikanOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanOmzet)}} </div>
                        </template>
                        <template v-slot:cell(unitOmzetPp)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unitOmzetPp) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(omzetPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.omzetPp == null">{{$helper.addThousandSeparator(row.item.omzetPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.omzetPp < 0">- Rp{{$helper.addThousandSeparator(row.item.omzetPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.omzetPp)}} </div>
                        </template>
                        <template v-slot:cell(kenaikanOmzetPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanOmzetPp == null">{{$helper.addThousandSeparator(row.item.kenaikanOmzetPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanOmzetPp < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanOmzetPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanOmzetPp)}} </div>
                        </template>
                        <template v-slot:cell(totalOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalOmzet == null">{{$helper.addThousandSeparator(row.item.totalOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.totalOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalOmzet)}} </div>
                        </template>
                        <template v-slot:cell(kenaikanTotalOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanTotalOmzet == null">{{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanTotalOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksiPp)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksiPp) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(bungaPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.bungaPp == null">{{$helper.addThousandSeparator(row.item.bungaPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.bungaPp < 0">- Rp{{$helper.addThousandSeparator(row.item.bungaPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.bungaPp)}} </div>
                        </template>
                        <template v-slot:cell(adminPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminPp == null">{{$helper.addThousandSeparator(row.item.adminPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminPp < 0">- Rp{{$helper.addThousandSeparator(row.item.adminPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminPp)}} </div>
                        </template>
                        <template v-slot:cell(dendaPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.dendaPp == null">{{$helper.addThousandSeparator(row.item.dendaPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.dendaPp < 0">- Rp{{$helper.addThousandSeparator(row.item.dendaPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.dendaPp)}} </div>
                        </template>
                        <template v-slot:cell(penaltiPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.penaltiPp == null">{{$helper.addThousandSeparator(row.item.penaltiPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penaltiPp < 0">- Rp{{$helper.addThousandSeparator(row.item.penaltiPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penaltiPp)}} </div>
                        </template>
                        <template v-slot:cell(keringananPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringananPp == null">{{$helper.addThousandSeparator(row.item.keringananPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringananPp < 0">- Rp{{$helper.addThousandSeparator(row.item.keringananPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringananPp)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksiPl)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksiPl) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(bungaPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.bungaPl == null">{{$helper.addThousandSeparator(row.item.bungaPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.bungaPl < 0">- Rp{{$helper.addThousandSeparator(row.item.bungaPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.bungaPl)}} </div>
                        </template>
                        <template v-slot:cell(adminPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminPl == null">{{$helper.addThousandSeparator(row.item.adminPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminPl < 0">- Rp{{$helper.addThousandSeparator(row.item.adminPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminPl)}} </div>
                        </template>
                        <template v-slot:cell(dendaPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.dendaPl == null">{{$helper.addThousandSeparator(row.item.dendaPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.dendaPl < 0">- Rp{{$helper.addThousandSeparator(row.item.dendaPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.dendaPl)}} </div>
                        </template>
                        <template v-slot:cell(penaltiPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.penaltiPl == null">{{$helper.addThousandSeparator(row.item.penaltiPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penaltiPl < 0">- Rp{{$helper.addThousandSeparator(row.item.penaltiPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penaltiPl)}} </div>
                        </template>
                        <template v-slot:cell(keringananPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringananPl == null">{{$helper.addThousandSeparator(row.item.keringananPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringananPl < 0">- Rp{{$helper.addThousandSeparator(row.item.keringananPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringananPl)}} </div>
                        </template>
                        <template v-slot:cell(jasaAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.jasaAwal == null">{{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.jasaAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                        </template>
                        <template v-slot:cell(adminAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminAwal == null">{{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.adminAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPp == null">{{$helper.addThousandSeparator(row.item.angsuranPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPp < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPp)}} </div>
                        </template>
                        <template v-slot:cell(pokokPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokPp == null">{{$helper.addThousandSeparator(row.item.pokokPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokokPp < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokPp)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPl == null">{{$helper.addThousandSeparator(row.item.angsuranPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPl < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPl)}} </div>
                        </template>
                        <template v-slot:cell(pokokPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokPl == null">{{$helper.addThousandSeparator(row.item.pokokPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokokPl < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokPl)}} </div>
                        </template>
                        <template v-slot:cell(totalBunga)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalBunga == null">{{$helper.addThousandSeparator(row.item.totalBunga)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalBunga < 0">- Rp{{$helper.addThousandSeparator(row.item.totalBunga).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalBunga)}} </div>
                        </template>
                        <template v-slot:cell(totalAdmin)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalAdmin == null">{{$helper.addThousandSeparator(row.item.totalAdmin)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalAdmin < 0">- Rp{{$helper.addThousandSeparator(row.item.totalAdmin).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalAdmin)}} </div>
                        </template>
                        <template v-slot:cell(totalDenda)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalDenda == null">{{$helper.addThousandSeparator(row.item.totalDenda)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalDenda < 0">- Rp{{$helper.addThousandSeparator(row.item.totalDenda).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalDenda)}} </div>
                        </template>
                        <template v-slot:cell(totalPenalti)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalPenalti == null">{{$helper.addThousandSeparator(row.item.totalPenalti)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalPenalti < 0">- Rp{{$helper.addThousandSeparator(row.item.totalPenalti).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalPenalti)}} </div>
                        </template>
                        <template v-slot:cell(totalKeringanan)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalKeringanan == null">{{$helper.addThousandSeparator(row.item.totalKeringanan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalKeringanan < 0">- Rp{{$helper.addThousandSeparator(row.item.totalKeringanan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalKeringanan)}} </div>
                        </template>
                        <template v-slot:cell(totalAll)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalAll == null"><strong>{{$helper.addThousandSeparator(row.item.totalAll)}} </strong></div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalAll < 0"><strong>- Rp{{$helper.addThousandSeparator(row.item.totalAll).replace("-", "")}}</strong></div>
                            <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(row.item.totalAll)}} </strong></div>
                        </template>
                        <template v-slot:cell(persediaan)="row">
                            <div class="text-right no-wrap" v-if="row.item.persediaan == null">{{$helper.addThousandSeparator(row.item.persediaan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.persediaan < 0">- Rp{{$helper.addThousandSeparator(row.item.persediaan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.persediaan)}} </div>
                        </template>
                        <template v-slot:cell(jumlahSetKirim)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahSetKirim) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(modalSetKirim)="row">
                            <div class="text-right no-wrap" v-if="row.item.modalSetKirim == null">{{$helper.addThousandSeparator(row.item.modalSetKirim)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.modalSetKirim < 0">- Rp{{$helper.addThousandSeparator(row.item.modalSetKirim).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.modalSetKirim)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTerjual)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTerjual) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(labaPenjualan)="row">
                            <div class="text-right no-wrap" v-if="row.item.labaPenjualan == null">{{$helper.addThousandSeparator(row.item.labaPenjualan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.labaPenjualan < 0">- Rp{{$helper.addThousandSeparator(row.item.labaPenjualan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.labaPenjualan)}} </div>
                        </template>
                    </b-table>

                </b-card>
            </div>
        </div>
        <!--
            ============================================================
            VARIAN "LAPORAN PER TAHUN" - dinonaktifkan.
            Referensi hanya menampilkan tabel per-cabang, jadi blok ini
            dimatikan lewat v-if="false" (bukan komentar HTML, karena
            markup di dalamnya memuat "--" yang menutup komentar).
            Kode lama tetap utuh bila nanti mau diaktifkan lagi.
            ============================================================
        -->
        <div v-if="false">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <b-card >
                    <template v-slot:header>
                        <h5>
                            <p class="mb-2">Laporan Omzet per Tahun <span>({{jenisTipeLaporan}}) </span>
                                <span v-if="selectedCabang != null">Cabang {{selectedCabang}}</span>
                                <span v-else>Semua Cabang</span>
                            </p>
                            <h6 class="mb-0">
                                Periode : 2016 - <span>{{ periodeCurrentYear }}</span>
                            </h6>
                        </h5>
                    </template>
                    <b-table show-empty hover
                        :busy="isBusy"
                        :items="showDataOmzet" 
                        :fields="fieldTahun" 
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data omzet.
                        </template>
                        <template v-slot:head(kenaikanOmzet)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Omzet 
                        </template>
                        <template v-slot:head(kenaikanOmzetPp)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Omzet Gadai PP 
                        </template>
                        <template v-slot:head(kenaikanTotalOmzet)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Total Omzet
                        </template>
                        <template v-slot:thead-top>
                            <b-tr>
                                <b-th class="custom-subheader-sticky"># </b-th>
                                <b-th colspan="3">
                                    Piutang 
                                    <i class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.hover title="Diambil dari data bulan Desember / terakhir pada tahun tersebut"></i>
                              
                                </b-th>
                                <b-th colspan="8">Omzet</b-th>
                                <b-th colspan="7">Pemasukan (Perpanjangan)</b-th>
                                <b-th colspan="8">Pemasukan (Pelunasan)</b-th>
                                <b-th colspan="2">Pemasukan (Gadai)</b-th>
                                <b-th colspan="6">Total Pemasukan
                                    <i class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.click="'Total Pemasukan = Jasa + Admin + Denda + Penalti + Keringanan + Jasa Awal + Admin Awal'"></i>
                                </b-th>
                                <b-th colspan="5">
                                    Lelang
                                    <i class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.hover title="Persediaan diambil dari data bulan Desember / terakhir pada tahun tersebut"></i>
                                </b-th>
                            </b-tr>
                        </template>
                        <template v-slot:custom-foot>
                            <td class="custom-footer-sticky"><strong>Total</strong></td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{$helper.addThousandSeparator(showDataOmzetAll.unitOmzet)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.omzet == null">{{$helper.addThousandSeparator(showDataOmzetAll.omzet)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.omzet < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.omzet).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.omzet)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.unitOmzetPp)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.omzetPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.omzetPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.omzetPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.omzetPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.omzetPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalOmzet == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalOmzet < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTransaksiPp)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.bungaPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.bungaPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.bungaPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.bungaPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.bungaPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.dendaPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.dendaPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.dendaPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.dendaPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.dendaPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.penaltiPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.penaltiPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.keringananPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.keringananPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.keringananPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.keringananPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.keringananPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.angsuranPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.angsuranPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp)}} </div>
                            </td>
                            <!-- <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.pokokPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.pokokPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.pokokPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.pokokPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.pokokPp)}} </div>
                            </td> -->
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTransaksiPl)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.bungaPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.bungaPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.bungaPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.bungaPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.bungaPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.dendaPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.dendaPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.dendaPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.dendaPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.dendaPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.penaltiPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.penaltiPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.keringananPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.keringananPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.keringananPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.keringananPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.keringananPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.angsuranPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.angsuranPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.pokokPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.pokokPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.pokokPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.pokokPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.pokokPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.jasaAwal == null">{{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminAwal == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminAwal < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalBunga == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalBunga)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalBunga < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalBunga).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalBunga)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalAdmin == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalAdmin < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalDenda == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalDenda)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalDenda < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalDenda).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalDenda)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalPenalti == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalPenalti < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalKeringanan == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalKeringanan < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalAll == null"><strong>{{$helper.addThousandSeparator(showDataOmzetAll.totalAll)}} </strong></div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalAll < 0"><strong>- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalAll).replace("-", "")}}</strong></div>
                                <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalAll)}} </strong></div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahSetKirim) }}                 
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.modalSetKirim == null">{{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.modalSetKirim < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTerjual) }}                 
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.labaPenjualan == null">{{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.labaPenjualan < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan)}} </div>
                            </td>
                        </template>
                        <template v-slot:cell(cabangName)="row">
                            <div class="no-wrap">
                                <strong>{{ row.item.cabangName }}</strong>
                            </div>
                        </template>
                        <template v-slot:cell(piutangBerjalan)="row">
                            <div class="text-right no-wrap" v-if="row.item.piutangBerjalan == null">{{$helper.addThousandSeparator(row.item.piutangBerjalan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.piutangBerjalan < 0">- Rp{{$helper.addThousandSeparator(row.item.piutangBerjalan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.piutangBerjalan)}} </div>
                        </template>
                        <template v-slot:cell(badDebt)="row">
                            <div class="text-right no-wrap" v-if="row.item.badDebt == null">{{$helper.addThousandSeparator(row.item.badDebt)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.badDebt < 0">- Rp{{$helper.addThousandSeparator(row.item.badDebt).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.badDebt)}} </div>
                        </template>
                        <template v-slot:cell(piutangMacet)="row">
                            <div class="text-right no-wrap" v-if="row.item.piutangMacet == null">{{$helper.addThousandSeparator(row.item.piutangMacet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.piutangMacet < 0">- Rp{{$helper.addThousandSeparator(row.item.piutangMacet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.piutangMacet)}} </div>
                        </template>
                        <template v-slot:cell(omzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.omzet == null">{{$helper.addThousandSeparator(row.item.omzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.omzet < 0">- Rp{{$helper.addThousandSeparator(row.item.omzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.omzet)}} </div>
                        </template>
                        <template v-slot:cell(unitOmzet)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unitOmzet) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(kenaikanOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanOmzet == null">{{$helper.addThousandSeparator(row.item.kenaikanOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanOmzet)}} </div>
                        </template>
                        <template v-slot:cell(unitOmzetPp)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unitOmzetPp) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(omzetPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.omzetPp == null">{{$helper.addThousandSeparator(row.item.omzetPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.omzetPp < 0">- Rp{{$helper.addThousandSeparator(row.item.omzetPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.omzetPp)}} </div>
                        </template>
                        <template v-slot:cell(kenaikanOmzetPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanOmzetPp == null">{{$helper.addThousandSeparator(row.item.kenaikanOmzetPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanOmzetPp < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanOmzetPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanOmzetPp)}} </div>
                        </template>
                        <template v-slot:cell(totalOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalOmzet == null">{{$helper.addThousandSeparator(row.item.totalOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.totalOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalOmzet)}} </div>
                        </template>
                        <template v-slot:cell(kenaikanTotalOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanTotalOmzet == null">{{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanTotalOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksiPp)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksiPp) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(bungaPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.bungaPp == null">{{$helper.addThousandSeparator(row.item.bungaPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.bungaPp < 0">- Rp{{$helper.addThousandSeparator(row.item.bungaPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.bungaPp)}} </div>
                        </template>
                        <template v-slot:cell(adminPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminPp == null">{{$helper.addThousandSeparator(row.item.adminPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminPp < 0">- Rp{{$helper.addThousandSeparator(row.item.adminPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminPp)}} </div>
                        </template>
                        <template v-slot:cell(dendaPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.dendaPp == null">{{$helper.addThousandSeparator(row.item.dendaPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.dendaPp < 0">- Rp{{$helper.addThousandSeparator(row.item.dendaPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.dendaPp)}} </div>
                        </template>
                        <template v-slot:cell(penaltiPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.penaltiPp == null">{{$helper.addThousandSeparator(row.item.penaltiPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penaltiPp < 0">- Rp{{$helper.addThousandSeparator(row.item.penaltiPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penaltiPp)}} </div>
                        </template>
                        <template v-slot:cell(keringananPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringananPp == null">{{$helper.addThousandSeparator(row.item.keringananPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringananPp < 0">- Rp{{$helper.addThousandSeparator(row.item.keringananPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringananPp)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksiPl)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksiPl) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(bungaPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.bungaPl == null">{{$helper.addThousandSeparator(row.item.bungaPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.bungaPl < 0">- Rp{{$helper.addThousandSeparator(row.item.bungaPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.bungaPl)}} </div>
                        </template>
                        <template v-slot:cell(adminPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminPl == null">{{$helper.addThousandSeparator(row.item.adminPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminPl < 0">- Rp{{$helper.addThousandSeparator(row.item.adminPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminPl)}} </div>
                        </template>
                        <template v-slot:cell(dendaPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.dendaPl == null">{{$helper.addThousandSeparator(row.item.dendaPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.dendaPl < 0">- Rp{{$helper.addThousandSeparator(row.item.dendaPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.dendaPl)}} </div>
                        </template>
                        <template v-slot:cell(penaltiPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.penaltiPl == null">{{$helper.addThousandSeparator(row.item.penaltiPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penaltiPl < 0">- Rp{{$helper.addThousandSeparator(row.item.penaltiPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penaltiPl)}} </div>
                        </template>
                        <template v-slot:cell(keringananPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringananPl == null">{{$helper.addThousandSeparator(row.item.keringananPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringananPl < 0">- Rp{{$helper.addThousandSeparator(row.item.keringananPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringananPl)}} </div>
                        </template>
                        <template v-slot:cell(jasaAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.jasaAwal == null">{{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.jasaAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                        </template>
                        <template v-slot:cell(adminAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminAwal == null">{{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.adminAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPp == null">{{$helper.addThousandSeparator(row.item.angsuranPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPp < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPp)}} </div>
                        </template>
                        <template v-slot:cell(pokokPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokPp == null">{{$helper.addThousandSeparator(row.item.pokokPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokokPp < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokPp)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPl == null">{{$helper.addThousandSeparator(row.item.angsuranPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPl < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPl)}} </div>
                        </template>
                        <template v-slot:cell(pokokPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokPl == null">{{$helper.addThousandSeparator(row.item.pokokPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokokPl < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokPl)}} </div>
                        </template>
                        <template v-slot:cell(totalBunga)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalBunga == null">{{$helper.addThousandSeparator(row.item.totalBunga)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalBunga < 0">- Rp{{$helper.addThousandSeparator(row.item.totalBunga).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalBunga)}} </div>
                        </template>
                        <template v-slot:cell(totalAdmin)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalAdmin == null">{{$helper.addThousandSeparator(row.item.totalAdmin)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalAdmin < 0">- Rp{{$helper.addThousandSeparator(row.item.totalAdmin).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalAdmin)}} </div>
                        </template>
                        <template v-slot:cell(totalDenda)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalDenda == null">{{$helper.addThousandSeparator(row.item.totalDenda)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalDenda < 0">- Rp{{$helper.addThousandSeparator(row.item.totalDenda).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalDenda)}} </div>
                        </template>
                        <template v-slot:cell(totalPenalti)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalPenalti == null">{{$helper.addThousandSeparator(row.item.totalPenalti)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalPenalti < 0">- Rp{{$helper.addThousandSeparator(row.item.totalPenalti).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalPenalti)}} </div>
                        </template>
                        <template v-slot:cell(totalKeringanan)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalKeringanan == null">{{$helper.addThousandSeparator(row.item.totalKeringanan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalKeringanan < 0">- Rp{{$helper.addThousandSeparator(row.item.totalKeringanan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalKeringanan)}} </div>
                        </template>
                        <template v-slot:cell(totalAll)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalAll == null"><strong>{{$helper.addThousandSeparator(row.item.totalAll)}} </strong></div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalAll < 0"><strong>- Rp{{$helper.addThousandSeparator(row.item.totalAll).replace("-", "")}}</strong></div>
                            <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(row.item.totalAll)}} </strong></div>
                        </template>
                        <template v-slot:cell(persediaan)="row">
                            <div class="text-right no-wrap" v-if="row.item.persediaan == null">{{$helper.addThousandSeparator(row.item.persediaan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.persediaan < 0">- Rp{{$helper.addThousandSeparator(row.item.persediaan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.persediaan)}} </div>
                        </template>
                        <template v-slot:cell(jumlahSetKirim)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahSetKirim) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(modalSetKirim)="row">
                            <div class="text-right no-wrap" v-if="row.item.modalSetKirim == null">{{$helper.addThousandSeparator(row.item.modalSetKirim)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.modalSetKirim < 0">- Rp{{$helper.addThousandSeparator(row.item.modalSetKirim).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.modalSetKirim)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTerjual)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTerjual) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(labaPenjualan)="row">
                            <div class="text-right no-wrap" v-if="row.item.labaPenjualan == null">{{$helper.addThousandSeparator(row.item.labaPenjualan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.labaPenjualan < 0">- Rp{{$helper.addThousandSeparator(row.item.labaPenjualan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.labaPenjualan)}} </div>
                        </template>
                    </b-table>

                </b-card>
            </div>
        </div>
        <div v-if="showWebCabang">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <!-- <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan Omzet <span> {{jenisTipeLaporan}}</span> Cabang</h4>
                        <h6>
                            Periode : <span v-if="periodeBulan != '-'">{{ periodeBulan }}</span> <span v-else>Tahun</span> <span>{{ periodeTahun }}</span>
                        </h6>
                    </div>
                </div> -->
                <div class="table-card">
                    <div class="table-responsive-wrapper">
                    <b-table show-empty hover1
                        :busy="isBusy"
                        :items="showDataOmzet" 
                        :fields="fieldCabang" 
                        :currentPage="currentPage" 
                        :perPage="perPage"
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data omzet.
                        </template>
                        <template v-slot:head(kenaikanOmzet)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Omzet 
                        </template>
                        <template v-slot:head(kenaikanOmzetPp)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Omzet Gadai PP 
                        </template>
                        <template v-slot:head(kenaikanTotalOmzet)>
                            <i class="fa fa-line-chart mr-1"></i>
                            Total Omzet
                        </template>
                        <template v-slot:thead-top>
                            <b-tr>
                                <b-th class="custom-subheader-sticky"># </b-th>
                                <b-th colspan="3">
                                    Piutang 
                                    <i v-if="periodeBulan == '-'" class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.hover title="Diambil dari data bulan Desember / terakhir pada tahun tersebut"></i>
                                </b-th>
                                <b-th colspan="8">Omzet</b-th>
                                <b-th colspan="7">Pemasukan (Perpanjangan)</b-th>
                                <b-th colspan="8">Pemasukan (Pelunasan)</b-th>
                                <b-th colspan="2">Pemasukan (Gadai)</b-th>
                                <b-th colspan="6">Total Pemasukan
                                    <i class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.click="'Total Pemasukan = Jasa + Admin + Denda + Penalti + Keringanan + Jasa Awal + Admin Awal'"></i>
                                </b-th>
                                <b-th colspan="5">
                                    Lelang
                                    <i v-if="periodeBulan == '-'" class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.hover title="Persediaan diambil dari data bulan Desember / terakhir pada tahun tersebut"></i>
                                </b-th>
                            </b-tr>
                        </template>
                        <template v-slot:custom-foot>
                            <td class="custom-footer-sticky"><strong>Total</strong></td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{$helper.addThousandSeparator(showDataOmzetAll.unitOmzet)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.omzet == null">{{$helper.addThousandSeparator(showDataOmzetAll.omzet)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.omzet < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.omzet).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.omzet)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.unitOmzetPp)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.omzetPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.omzetPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.omzetPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.omzetPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.omzetPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalOmzet == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalOmzet < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalOmzet)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTransaksiPp)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.bungaPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.bungaPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.bungaPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.bungaPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.bungaPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.dendaPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.dendaPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.dendaPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.dendaPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.dendaPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.penaltiPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.penaltiPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.penaltiPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.keringananPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.keringananPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.keringananPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.keringananPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.keringananPp)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.angsuranPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.angsuranPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.angsuranPp)}} </div>
                            </td>
                            <!-- <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.pokokPp == null">{{$helper.addThousandSeparator(showDataOmzetAll.pokokPp)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.pokokPp < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.pokokPp).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.pokokPp)}} </div>
                            </td> -->
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTransaksiPl)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.bungaPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.bungaPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.bungaPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.bungaPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.bungaPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.dendaPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.dendaPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.dendaPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.dendaPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.dendaPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.penaltiPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.penaltiPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.penaltiPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.keringananPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.keringananPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.keringananPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.keringananPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.keringananPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.angsuranPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.angsuranPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.angsuranPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.pokokPl == null">{{$helper.addThousandSeparator(showDataOmzetAll.pokokPl)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.pokokPl < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.pokokPl).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.pokokPl)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.jasaAwal == null">{{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.jasaAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.adminAwal == null">{{$helper.addThousandSeparator(showDataOmzetAll.adminAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.adminAwal < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.adminAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.adminAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalBunga == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalBunga)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalBunga < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalBunga).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalBunga)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalAdmin == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalAdmin < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalAdmin)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalDenda == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalDenda)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalDenda < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalDenda).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalDenda)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalPenalti == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalPenalti < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalPenalti)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalKeringanan == null">{{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalKeringanan < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalKeringanan)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.totalAll == null"><strong>{{$helper.addThousandSeparator(showDataOmzetAll.totalAll)}} </strong></div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.totalAll < 0"><strong>- Rp{{$helper.addThousandSeparator(showDataOmzetAll.totalAll).replace("-", "")}}</strong></div>
                                <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.totalAll)}} </strong></div>
                            </td>
                            <td class="custom-footer-wrapper">
                                
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahSetKirim) }}                 
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.modalSetKirim == null">{{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.modalSetKirim < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.modalSetKirim)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataOmzetAll.jumlahTerjual) }}                 
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataOmzetAll.labaPenjualan == null">{{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataOmzetAll.labaPenjualan < 0">- Rp{{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataOmzetAll.labaPenjualan)}} </div>
                            </td>
                        </template>
                        <template v-slot:cell(cabangName)="row">
                            <div class="no-wrap">
                                <strong>{{ row.item.cabangName }}</strong>
                            </div>
                        </template>
                        <template v-slot:cell(piutangBerjalan)="row">
                            <div class="text-right no-wrap" v-if="row.item.piutangBerjalan == null">{{$helper.addThousandSeparator(row.item.piutangBerjalan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.piutangBerjalan < 0">- Rp{{$helper.addThousandSeparator(row.item.piutangBerjalan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.piutangBerjalan)}} </div>
                        </template>
                        <template v-slot:cell(badDebt)="row">
                            <div class="text-right no-wrap" v-if="row.item.badDebt == null">{{$helper.addThousandSeparator(row.item.badDebt)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.badDebt < 0">- Rp{{$helper.addThousandSeparator(row.item.badDebt).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.badDebt)}} </div>
                        </template>
                        <template v-slot:cell(piutangMacet)="row">
                            <div class="text-right no-wrap" v-if="row.item.piutangMacet == null">{{$helper.addThousandSeparator(row.item.piutangMacet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.piutangMacet < 0">- Rp{{$helper.addThousandSeparator(row.item.piutangMacet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.piutangMacet)}} </div>
                        </template>
                        <template v-slot:cell(omzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.omzet == null">{{$helper.addThousandSeparator(row.item.omzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.omzet < 0">- Rp{{$helper.addThousandSeparator(row.item.omzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.omzet)}} </div>
                        </template>
                        <template v-slot:cell(unitOmzet)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unitOmzet) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(kenaikanOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanOmzet == null">{{$helper.addThousandSeparator(row.item.kenaikanOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanOmzet)}} </div>
                        </template>
                        <template v-slot:cell(unitOmzetPp)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unitOmzetPp) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(omzetPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.omzetPp == null">{{$helper.addThousandSeparator(row.item.omzetPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.omzetPp < 0">- Rp{{$helper.addThousandSeparator(row.item.omzetPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.omzetPp)}} </div>
                        </template>
                        <template v-slot:cell(kenaikanOmzetPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanOmzetPp == null">{{$helper.addThousandSeparator(row.item.kenaikanOmzetPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanOmzetPp < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanOmzetPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanOmzetPp)}} </div>
                        </template>
                        <template v-slot:cell(totalOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalOmzet == null">{{$helper.addThousandSeparator(row.item.totalOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.totalOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalOmzet)}} </div>
                        </template>
                        <template v-slot:cell(kenaikanTotalOmzet)="row">
                            <div class="text-right no-wrap" v-if="row.item.kenaikanTotalOmzet == null">{{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.kenaikanTotalOmzet < 0">- Rp{{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.kenaikanTotalOmzet)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksiPp)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksiPp) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(bungaPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.bungaPp == null">{{$helper.addThousandSeparator(row.item.bungaPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.bungaPp < 0">- Rp{{$helper.addThousandSeparator(row.item.bungaPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.bungaPp)}} </div>
                        </template>
                        <template v-slot:cell(adminPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminPp == null">{{$helper.addThousandSeparator(row.item.adminPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminPp < 0">- Rp{{$helper.addThousandSeparator(row.item.adminPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminPp)}} </div>
                        </template>
                        <template v-slot:cell(dendaPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.dendaPp == null">{{$helper.addThousandSeparator(row.item.dendaPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.dendaPp < 0">- Rp{{$helper.addThousandSeparator(row.item.dendaPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.dendaPp)}} </div>
                        </template>
                        <template v-slot:cell(penaltiPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.penaltiPp == null">{{$helper.addThousandSeparator(row.item.penaltiPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penaltiPp < 0">- Rp{{$helper.addThousandSeparator(row.item.penaltiPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penaltiPp)}} </div>
                        </template>
                        <template v-slot:cell(keringananPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringananPp == null">{{$helper.addThousandSeparator(row.item.keringananPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringananPp < 0">- Rp{{$helper.addThousandSeparator(row.item.keringananPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringananPp)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksiPl)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksiPl) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(bungaPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.bungaPl == null">{{$helper.addThousandSeparator(row.item.bungaPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.bungaPl < 0">- Rp{{$helper.addThousandSeparator(row.item.bungaPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.bungaPl)}} </div>
                        </template>
                        <template v-slot:cell(adminPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminPl == null">{{$helper.addThousandSeparator(row.item.adminPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminPl < 0">- Rp{{$helper.addThousandSeparator(row.item.adminPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminPl)}} </div>
                        </template>
                        <template v-slot:cell(dendaPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.dendaPl == null">{{$helper.addThousandSeparator(row.item.dendaPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.dendaPl < 0">- Rp{{$helper.addThousandSeparator(row.item.dendaPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.dendaPl)}} </div>
                        </template>
                        <template v-slot:cell(penaltiPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.penaltiPl == null">{{$helper.addThousandSeparator(row.item.penaltiPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penaltiPl < 0">- Rp{{$helper.addThousandSeparator(row.item.penaltiPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penaltiPl)}} </div>
                        </template>
                        <template v-slot:cell(keringananPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringananPl == null">{{$helper.addThousandSeparator(row.item.keringananPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringananPl < 0">- Rp{{$helper.addThousandSeparator(row.item.keringananPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringananPl)}} </div>
                        </template>
                        <template v-slot:cell(jasaAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.jasaAwal == null">{{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.jasaAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                        </template>
                        <template v-slot:cell(adminAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminAwal == null">{{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.adminAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPp == null">{{$helper.addThousandSeparator(row.item.angsuranPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPp < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPp)}} </div>
                        </template>
                        <template v-slot:cell(pokokPp)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokPp == null">{{$helper.addThousandSeparator(row.item.pokokPp)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokokPp < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokPp).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokPp)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPl == null">{{$helper.addThousandSeparator(row.item.angsuranPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPl < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPl)}} </div>
                        </template>
                        <template v-slot:cell(pokokPl)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokPl == null">{{$helper.addThousandSeparator(row.item.pokokPl)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokokPl < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokPl).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokPl)}} </div>
                        </template>
                        <template v-slot:cell(totalBunga)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalBunga == null">{{$helper.addThousandSeparator(row.item.totalBunga)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalBunga < 0">- Rp{{$helper.addThousandSeparator(row.item.totalBunga).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalBunga)}} </div>
                        </template>
                        <template v-slot:cell(totalAdmin)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalAdmin == null">{{$helper.addThousandSeparator(row.item.totalAdmin)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalAdmin < 0">- Rp{{$helper.addThousandSeparator(row.item.totalAdmin).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalAdmin)}} </div>
                        </template>
                        <template v-slot:cell(totalDenda)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalDenda == null">{{$helper.addThousandSeparator(row.item.totalDenda)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalDenda < 0">- Rp{{$helper.addThousandSeparator(row.item.totalDenda).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalDenda)}} </div>
                        </template>
                        <template v-slot:cell(totalPenalti)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalPenalti == null">{{$helper.addThousandSeparator(row.item.totalPenalti)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalPenalti < 0">- Rp{{$helper.addThousandSeparator(row.item.totalPenalti).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalPenalti)}} </div>
                        </template>
                        <template v-slot:cell(totalKeringanan)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalKeringanan == null">{{$helper.addThousandSeparator(row.item.totalKeringanan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalKeringanan < 0">- Rp{{$helper.addThousandSeparator(row.item.totalKeringanan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.totalKeringanan)}} </div>
                        </template>
                        <template v-slot:cell(totalAll)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalAll == null"><strong>{{$helper.addThousandSeparator(row.item.totalAll)}} </strong></div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalAll < 0"><strong>- Rp{{$helper.addThousandSeparator(row.item.totalAll).replace("-", "")}}</strong></div>
                            <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(row.item.totalAll)}} </strong></div>
                        </template>
                        <template v-slot:cell(persediaan)="row">
                            <div class="text-right no-wrap" v-if="row.item.persediaan == null">{{$helper.addThousandSeparator(row.item.persediaan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.persediaan < 0">- Rp{{$helper.addThousandSeparator(row.item.persediaan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.persediaan)}} </div>
                        </template>
                        <template v-slot:cell(jumlahSetKirim)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahSetKirim) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(modalSetKirim)="row">
                            <div class="text-right no-wrap" v-if="row.item.modalSetKirim == null">{{$helper.addThousandSeparator(row.item.modalSetKirim)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.modalSetKirim < 0">- Rp{{$helper.addThousandSeparator(row.item.modalSetKirim).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.modalSetKirim)}} </div>
                        </template>
                        <template v-slot:cell(jumlahTerjual)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTerjual) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(labaPenjualan)="row">
                            <div class="text-right no-wrap" v-if="row.item.labaPenjualan == null">{{$helper.addThousandSeparator(row.item.labaPenjualan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.labaPenjualan < 0">- Rp{{$helper.addThousandSeparator(row.item.labaPenjualan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.labaPenjualan)}} </div>
                        </template>
                    </b-table>
                    </div>

                    <div class="table-pagination-footer d-flex align-items-center justify-content-between">
                        <div class="limit-wrapper d-flex align-items-center">
                            <span class="limit-label mr-2">Tampilkan</span>
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options" class="limit-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="entries-info ml-3">{{ totalViewText }}</span>
                        </div>
                        <b-pagination class="custom-pagination mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                            prev-text="‹"
                            next-text="›"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>

                </div>
            </div>
        </div>

        <b-modal id="modal-bulan-search" title="Laporan per Bulan" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting" hide-footer>
            <div class="form-content-wrapper mb-0">
                <b-form-group label="Cabang">
                    <b-form-checkbox 
                        v-model="input.allCabang"
                        name="allCabang"
                        class="mb-2"
                    >
                        Semua Cabang
                    </b-form-checkbox>
                    <div class="mr-2">
                        <multiselect
                            name="cabang"
                            :disabled=input.allCabang
                            v-model="input.cabang" 
                            :options="cabangOption" 
                            :internal-search="true"
                            :allow-empty="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="-- Pilih Cabang --"
                        />
                    </div>
                </b-form-group>
                <b-form-group label="Tipe Pinjaman">
                    <b-form-select v-model="input.tipePinjaman" name="tipePinjaman" :options="tipePinjamanOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
                <b-form-group label="Tahun">
                    <b-form-select v-model="input.tahun" name="tahun" :options="tahunOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <div class="form-wrapper-btn">
                <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmBulanWeb()">
                    Lihat di Web
                </b-button>
                <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmBulanDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-tahun-search" title="Laporan per Tahun" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting" hide-footer>
            <div class="form-content-wrapper mb-0">
                <b-form-group label="Cabang">
                    <b-form-checkbox 
                        v-model="input.allCabangTahun"
                        name="allCabang"
                        class="mb-2"
                    >
                        Semua Cabang
                    </b-form-checkbox>
                    <div class="mr-2">
                        <multiselect
                            name="cabang"
                            :disabled=input.allCabangTahun
                            v-model="input.cabangTahun" 
                            :options="cabangOption" 
                            :internal-search="true"
                            :allow-empty="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="-- Pilih Cabang --"
                        />
                    </div>
                </b-form-group>
                <b-form-group label="Tipe Pinjaman">
                    <b-form-select v-model="input.tipePinjamanTahun" name="tipePinjaman" :options="tipePinjamanOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <div class="form-wrapper-btn">
                <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmTahunWeb()">
                    Lihat di Web
                </b-button>
                <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmTahunDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-cabang-search" title="Laporan per Cabang" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting" hide-footer>
            <div class="form-content-wrapper mb-0">
                <b-form-group label="Periode">
                    <div class="d-flex align-items-center search-input-wrapper">
                        <b-form-select class="mr-2" v-model="input.bulanCabang" id="inputBulanCabang" name="inputBulanCabang" :options="optionBulan">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-model="input.tahunCabang" id="inputTahunCabang" name="inputTahunCabang" :options="tahunOption">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-form-group>
                <b-form-group label="Tipe Pinjaman">
                    <b-form-select v-model="input.tipePinjamanCabang" name="tipePinjamanCabang" :options="tipePinjamanOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <div class="form-wrapper-btn">
                <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmCabangWeb()">
                    Lihat di Web
                </b-button>
                <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmCabangDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-bulan-webPassword" content-class="lapeks-modal" @shown="focusBulanWebPassword" title="Confirm Web Laporan Bulan Gadai Baru" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webBulanPasswordForm" @submit.prevent="openBulanWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordBulanWeb"
                        v-model="input.passwordBulanWeb"
                        name="passwordBulanWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webBulanPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-bulan-downloadPassword" content-class="lapeks-modal" @shown="focusBulanDownloadPassword" title="Confirm Download Laporan Bulan Gadai Baru" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadBulanPasswordForm" @submit.prevent="openBulanDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordBulanDownload"
                        v-model="input.passwordBulanDownload"
                        name="passwordBulanDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadBulanPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-tahun-webPassword" content-class="lapeks-modal" @shown="focusTahunWebPassword" title="Confirm Web Laporan Tahun Gadai Baru" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webTahunPasswordForm" @submit.prevent="openTahunWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordTahunWeb"
                        v-model="input.passwordTahunWeb"
                        name="passwordTahunWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webTahunPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-cabang-webPassword" content-class="lapeks-modal" @shown="focusCabangWebPassword" title="Confirm Web Laporan Cabang Gadai Baru" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webCabangPasswordForm" @submit.prevent="openCabangWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordCabangWeb"
                        v-model="input.passwordCabangWeb"
                        name="passwordCabangWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webCabangPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-cabang-downloadPassword" content-class="lapeks-modal" @shown="focusCabangDownloadPassword" title="Confirm Download Laporan Cabang Gadai Baru" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadCabangPasswordForm" @submit.prevent="openCabangDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordCabangDownload"
                        v-model="input.passwordCabangDownload"
                        name="passwordCabangDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadCabangPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" content-class="lapeks-modal" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'laporan-omzet',
    data(){
        return{
            isSubmitting: false,
            input:{
                tahun: null,
                allCabang: false,
                allCabangTahun: false,
                cabang: null,
                cabangTahun: null,
                tipePinjaman: null,
                tipePinjamanTahun: null,
                tipePinjamanCabang: null,
                tahunCabang: null,
                bulanCabang: null,

                passwordBulanWeb: "",
                passwordBulanDownload: "",
                passwordTahunWeb: "",
                passwordTahunDownload: "",
                passwordCabangWeb: "",
                passwordCabangDownload: "",

                //
                
                show: 10,
                filterCabang: null,
            },
            cabangOption: [],
            tipePinjamanOption: [],
            tahunOption: [],
            optionBulan: [
                { value: "0", text: "-" },
                { value: "1", text: "Januari" },
                { value: "2", text: "Februari" },
                { value: "3", text: "Maret" },
                { value: "4", text: "April" },
                { value: "5", text: "Mei" },
                { value: "6", text: "Juni" },
                { value: "7", text: "Juli" },
                { value: "8", text: "Agustus" },
                { value: "9", text: "September" },
                { value: "10", text: "Oktober" },
                { value: "11", text: "November" },
                { value: "12", text: "Desember" }
            ],
            isLoading: false,
            filePathDownload: "",
            query: "",
            showWebBulan: false,
            showWebCabang: false,
            showWebTahun: false,


            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            periodeBulan: '',
            periodeTahun: '',
            periodeCurrentYear: '',
            jenisTipeLaporan: '',
            selectedCabang: null,
            isBusy: true,
            fields: [
                { key: "cabangName", label: "Bulan", stickyColumn: true },
                { key: "piutangBerjalan", label: "Piutang Berjalan", sortable: true },
                { key: "badDebt", label: "Bad Debt", sortable: true },
                { key: "piutangMacet", label: "Piutang Macet", sortable: true },
                { key: "unitOmzet", label: "# Omzet Gadai Baru", sortable: true },
                { key: "omzet", label: "Omzet Gadai Baru", sortable: true },
                { key: "kenaikanOmzet", label: "Kenaikan Omzet Gadai Baru", sortable: true },
                { key: "unitOmzetPp", label: "# Omzet Gadai PP", sortable: true },
                { key: "omzetPp", label: "Omzet Gadai PP", sortable: true },
                { key: "kenaikanOmzetPp", label: "Kenaikan Omzet Pp", sortable: true },
                { key: "totalOmzet", label: "Total Omzet", sortable: true },
                { key: "kenaikanTotalOmzet", label: "Kenaikan Total Omzet", sortable: true },
                { key: "jumlahTransaksiPp", label: "# Transaksi", sortable: true },
                { key: "bungaPp", label: "Bunga", sortable: true },
                { key: "adminPp", label: "Admin", sortable: true },
                { key: "dendaPp", label: "Denda", sortable: true },
                { key: "penaltiPp", label: "Penalti", sortable: true },
                { key: "keringananPp", label: "Keringanan", sortable: true },
                { key: "angsuranPp", label: "Angsuran", sortable: true},
                // { key: "pokokPp", label: "Pokok", sortable: true},
                { key: "jumlahTransaksiPl", label: "# Transaksi", sortable: true },
                { key: "bungaPl", label: "Bunga", sortable: true },
                { key: "adminPl", label: "Admin", sortable: true },
                { key: "dendaPl", label: "Denda", sortable: true },
                { key: "penaltiPl", label: "Penalti", sortable: true },
                { key: "keringananPl", label: "Keringanan", sortable: true },
                { key: "angsuranPl", label: "Angsuran", sortable: true},
                { key: "pokokPl", label: "Pokok", sortable: true},
                { key: "jasaAwal", label: "Jasa Awal", sortable: true},
                { key: "adminAwal", label: "Admin Awal", sortable: true},
                { key: "totalBunga", label: "Total Bunga", sortable: true},
                { key: "totalAdmin", label: "Total Admin", sortable: true},
                { key: "totalDenda", label: "Total Denda", sortable: true},
                { key: "totalPenalti", label: "Total Penalti", sortable: true},
                { key: "totalKeringanan", label: "Total Keringanan", sortable: true},
                { key: "totalAll", label: "Total Pemasukan", sortable: true},
                { key: "persediaan", label: "Persediaan", sortable: true },
                { key: "jumlahSetKirim", label: "# Set Kirim", sortable: true },
                { key: "modalSetKirim", label: "Modal Set Kirim", sortable: true },
                { key: "jumlahTerjual", label: "# Terjual", sortable: true },
                { key: "labaPenjualan", label: "Laba Penjualan", sortable: true },
            ],
            fieldTahun: [
                { key: "cabangName", label: "Tahun", stickyColumn: true },
                { key: "piutangBerjalan", label: "Piutang Berjalan", sortable: true },
                { key: "badDebt", label: "Bad Debt", sortable: true },
                { key: "piutangMacet", label: "Piutang Macet", sortable: true },
                { key: "unitOmzet", label: "# Omzet Gadai Baru", sortable: true },
                { key: "omzet", label: "Omzet Gadai Baru", sortable: true },
                { key: "kenaikanOmzet", label: "Kenaikan Omzet Gadai Baru", sortable: true },
                { key: "unitOmzetPp", label: "# Omzet Gadai PP", sortable: true },
                { key: "omzetPp", label: "Omzet Gadai PP", sortable: true },
                { key: "kenaikanOmzetPp", label: "Kenaikan Omzet Gadai PP", sortable: true },
                { key: "totalOmzet", label: "Total Omzet", sortable: true },
                { key: "kenaikanTotalOmzet", label: "Kenaikan Total Omzet", sortable: true },
                { key: "jumlahTransaksiPp", label: "# Transaksi", sortable: true },
                { key: "bungaPp", label: "Bunga", sortable: true },
                { key: "adminPp", label: "Admin", sortable: true },
                { key: "dendaPp", label: "Denda", sortable: true },
                { key: "penaltiPp", label: "Penalti", sortable: true },
                { key: "keringananPp", label: "Keringanan", sortable: true },
                { key: "angsuranPp", label: "Angsuran", sortable: true},
                // { key: "pokokPp", label: "Pokok", sortable: true},
                { key: "jumlahTransaksiPl", label: "# Transaksi", sortable: true },
                { key: "bungaPl", label: "Bunga", sortable: true },
                { key: "adminPl", label: "Admin", sortable: true },
                { key: "dendaPl", label: "Denda", sortable: true },
                { key: "penaltiPl", label: "Penalti", sortable: true },
                { key: "keringananPl", label: "Keringanan", sortable: true },
                { key: "angsuranPl", label: "Angsuran", sortable: true},
                { key: "pokokPl", label: "Pokok", sortable: true},
                { key: "jasaAwal", label: "Jasa Awal", sortable: true},
                { key: "adminAwal", label: "Admin Awal", sortable: true},
                { key: "totalBunga", label: "Total Bunga", sortable: true},
                { key: "totalAdmin", label: "Total Admin", sortable: true},
                { key: "totalDenda", label: "Total Denda", sortable: true},
                { key: "totalPenalti", label: "Total Penalti", sortable: true},
                { key: "totalKeringanan", label: "Total Keringanan", sortable: true},
                { key: "totalAll", label: "Total Pemasukan", sortable: true},
                { key: "persediaan", label: "Persediaan", sortable: true },
                { key: "jumlahSetKirim", label: "# Set Kirim", sortable: true },
                { key: "modalSetKirim", label: "Modal Set Kirim", sortable: true },
                { key: "jumlahTerjual", label: "# Terjual", sortable: true },
                { key: "labaPenjualan", label: "Laba Penjualan", sortable: true },
            ],
            fieldCabang: [
                { key: "cabangName", label: "Cabang", stickyColumn: true },
                { key: "piutangBerjalan", label: "Piutang Berjalan", sortable: true },
                { key: "badDebt", label: "Bad Debt", sortable: true },
                { key: "piutangMacet", label: "Piutang Macet", sortable: true },
                { key: "unitOmzet", label: "# Omzet Gadai Baru", sortable: true },
                { key: "omzet", label: "Omzet Gadai Baru", sortable: true },
                { key: "kenaikanOmzet", label: "Kenaikan Omzet Gadai Baru", sortable: true },
                { key: "unitOmzetPp", label: "# Omzet Gadai PP", sortable: true },
                { key: "omzetPp", label: "Omzet Gadai PP", sortable: true },
                { key: "kenaikanOmzetPp", label: "Kenaikan Omzet Pp", sortable: true },
                { key: "totalOmzet", label: "Total Omzet", sortable: true },
                { key: "kenaikanTotalOmzet", label: "Kenaikan Total Omzet", sortable: true },
                { key: "jumlahTransaksiPp", label: "# Transaksi", sortable: true },
                { key: "bungaPp", label: "Bunga", sortable: true },
                { key: "adminPp", label: "Admin", sortable: true },
                { key: "dendaPp", label: "Denda", sortable: true },
                { key: "penaltiPp", label: "Penalti", sortable: true },
                { key: "keringananPp", label: "Keringanan", sortable: true },
                { key: "angsuranPp", label: "Angsuran", sortable: true},
                // { key: "pokokPp", label: "Pokok", sortable: true},
                { key: "jumlahTransaksiPl", label: "# Transaksi", sortable: true },
                { key: "bungaPl", label: "Bunga", sortable: true },
                { key: "adminPl", label: "Admin", sortable: true },
                { key: "dendaPl", label: "Denda", sortable: true },
                { key: "penaltiPl", label: "Penalti", sortable: true },
                { key: "keringananPl", label: "Keringanan", sortable: true },
                { key: "angsuranPl", label: "Angsuran", sortable: true},
                { key: "pokokPl", label: "Pokok", sortable: true},
                { key: "jasaAwal", label: "Jasa Awal", sortable: true},
                { key: "adminAwal", label: "Admin Awal", sortable: true},
                { key: "totalBunga", label: "Total Bunga", sortable: true},
                { key: "totalAdmin", label: "Total Admin", sortable: true},
                { key: "totalDenda", label: "Total Denda", sortable: true},
                { key: "totalPenalti", label: "Total Penalti", sortable: true},
                { key: "totalKeringanan", label: "Total Keringanan", sortable: true},
                { key: "totalAll", label: "Total Pemasukan", sortable: true},
                { key: "persediaan", label: "Persediaan", sortable: true },
                { key: "jumlahSetKirim", label: "# Set Kirim", sortable: true },
                { key: "modalSetKirim", label: "Modal Set Kirim", sortable: true },
                { key: "jumlahTerjual", label: "# Terjual", sortable: true },
                { key: "labaPenjualan", label: "Laba Penjualan", sortable: true },
            ],

            showDataOmzetAll : [],
            showDataOmzet: [],
        }
    }, 
    methods: {

        init(){
            this.initStatus = 0
			var thisYear = new Date().getFullYear()
			for(var i = 2016; i <= thisYear; i++) {
				this.tahunOption.push(i)
			}
            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    this.cabangOption.push(element)
                })
            })

            // Tipe pinjaman mengikuti master (jenis_pinjaman), bukan daftar tetap
            let getTipePinjaman = this.$axios.get("tipe-pinjaman/selection").then(response => {
                this.tipePinjamanOption = response.data.map(item => ({ value: item.id, text: item.name }))
            })

            Promise.all([getCabang, getTipePinjaman]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        focusBulanWebPassword(){
            this.$refs.passwordBulanWeb.focus()
        },

        focusBulanDownloadPassword(){
            this.$refs.passwordBulanDownload.focus()
        },

        focusTahunWebPassword(){
            this.$refs.passwordTahunWeb.focus()
        },

        focusTahunDownloadPassword(){
            this.$refs.passwordTahunDownload.focus()
        },

        focusCabangWebPassword(){
            this.$refs.passwordCabangWeb.focus()
        },

        focusCabangDownloadPassword(){
            this.$refs.passwordCabangDownload.focus()
        },

        openLaporanBulan(){
            this.$bvModal.show('modal-bulan-search')
        },

        openLaporanTahun(){
            this.$bvModal.show('modal-tahun-search')
        },

        openLaporanCabang(){
            this.$bvModal.show('modal-cabang-search')
        },

        confirmBulanWeb(){
            if(this.input.allCabang == false && this.input.cabang == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjaman)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman laporan!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tahun)){
                this.$helper.toastErr(this, "Mohon isi tahun laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openBulanWeb()
                    this.input.passwordBulanWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-bulan-webPassword')
                }
            }
        },

        openBulanWeb(){
            this.showWebBulan = true
            this.showWebTahun = false
            this.showWebCabang = false
            this.selectedCabang = null
            this.isLoading = true
            this.$bvModal.hide('modal-bulan-search')
            this.$bvModal.hide('modal-bulan-webPassword')
            setTimeout(() => { this.axiosBulanWeb() }, 500)
        },

        axiosBulanWeb(){
            
            if(this.input.allCabang){
                this.selectedCabang = null
                this.query = `cabangId=-1&tahun=${this.input.tahun}&tipe=${this.input.tipePinjaman}&password=${this.input.passwordBulanWeb}`
            }else{
                let idxCabang= this.cabangOption.findIndex(item => item.id == this.input.cabang.id)
                this.selectedCabang = this.cabangOption[idxCabang].name
                this.query = `cabangId=${this.input.cabang.id}&tahun=${this.input.tahun}&tipe=${this.input.tipePinjaman}&password=${this.input.passwordBulanWeb}`
            }
            this.$axios.get(`laporan-eksekutif/omzet/bulan?${this.query}`).then(response => {
                this.showDataOmzetAll = response.data
                this.showDataOmzet = response.data.entries
                this.isLoading = false
                this.isBusy = false
                this.periodeBulan = '-'
                this.periodeTahun = this.input.tahun
                let idxTipeLaporan= this.tipePinjamanOption.findIndex(item => item.value == this.input.tipePinjaman)
                this.jenisTipeLaporan = this.tipePinjamanOption[idxTipeLaporan].text
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordBulanWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordBulanWeb = ""
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordBulanWeb = ""
                this.showWebBulan = false
                this.showWebTahun = false
                this.showWebCabang = false
                this.isLoading = false
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmBulanDownload(){
            if(this.input.allCabang == false && this.input.cabang == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjaman)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman laporan!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tahun)){
                this.$helper.toastErr(this, "Mohon isi tahun laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openBulanDownload()
                    this.input.passwordBulanDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-bulan-downloadPassword')
                }
            }
        },

        openBulanDownload(){
            this.showWebBulan = false
            this.showWebTahun = false
            this.showWebCabang = false
            this.isLoading = true
            this.$bvModal.hide('modal-bulan-search')
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-bulan-downloadPassword')
            setTimeout(() => { this.axiosBulanDownload() }, 500)
        },
        
        axiosBulanDownload(){
            console.log(this.input.allCabang)
            if(this.input.allCabang){
                this.query = `cabangId=-1&tahun=${this.input.tahun}&tipe=${this.input.tipePinjaman}&password=${this.input.passwordBulanDownload}`
            }else{
                this.query = `cabangId=${this.input.cabang.id}&tahun=${this.input.tahun}&tipe=${this.input.tipePinjaman}&password=${this.input.passwordBulanDownload}`
            }
            this.$axios.get(`laporan-eksekutif/omzet/bulan/dl?${this.query}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordBulanDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordBulanDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordBulanDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmTahunWeb(){
            if(this.input.allCabangTahun == false && this.input.cabangTahun == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanTahun)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openTahunWeb()
                    this.input.passwordTahunWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-tahun-webPassword')
                }
            }
        },

        openTahunWeb(){
            this.showWebBulan = false
            this.showWebTahun = true
            this.showWebCabang = false
            this.selectedCabang = null
            this.isLoading = true
            this.$bvModal.hide('modal-tahun-search')
            this.$bvModal.hide('modal-tahun-webPassword')
            setTimeout(() => { this.axiosTahunWeb() }, 500)
        },

        axiosTahunWeb(){
            if(this.input.allCabangTahun){
                this.selectedCabang = null
                this.query = `cabangId=-1&tipe=${this.input.tipePinjamanTahun}&password=${this.input.passwordTahunWeb}`
            }else{
                let idxCabang= this.cabangOption.findIndex(item => item.id == this.input.cabangTahun.id)
                this.selectedCabang = this.cabangOption[idxCabang].name
                this.query = `cabangId=${this.input.cabangTahun.id}&tipe=${this.input.tipePinjamanTahun}&password=${this.input.passwordTahunWeb}`
            }
            this.$axios.get(`laporan-eksekutif/omzet/tahun?${this.query}`).then(response => {
                this.showDataOmzetAll = response.data
                this.showDataOmzet = response.data.entries
                this.isLoading = false
                this.isBusy = false
                //  get current year
                var date = new Date();
                this.periodeCurrentYear = date.getFullYear();
                //
                let idxTipeLaporan= this.tipePinjamanOption.findIndex(item => item.value == this.input.tipePinjamanTahun)
                this.jenisTipeLaporan = this.tipePinjamanOption[idxTipeLaporan].text
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordTahunWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordTahunWeb = ""
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordTahunWeb = ""
                this.showWebBulan = false
                this.showWebTahun = false
                this.showWebCabang = false
                this.isLoading = false
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmTahunDownload(){
            if(this.input.allCabangTahun == false && this.input.cabangTahun == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanTahun)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openTahunDownload()
                    this.input.passwordTahunDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-tahun-downloadPassword')
                }
            }
        },

        openTahunDownload(){
            this.showWebBulan = false
            this.showWebTahun = false
            this.showWebCabang = false
            this.isLoading = true
            this.$bvModal.hide('modal-tahun-search')
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-tahun-downloadPassword')
            setTimeout(() => { this.axiosTahunDownload() }, 500)
        },

        axiosTahunDownload(){
            if(this.input.allCabangTahun){
                this.query = `cabangId=-1&tipe=${this.input.tipePinjamanTahun}&password=${this.input.passwordTahunDownload}`
            }else{
                this.query = `cabangId=${this.input.cabangTahun.id}&tipe=${this.input.tipePinjamanTahun}&password=${this.input.passwordTahunDownload}`
            }
            this.$axios.get(`laporan-eksekutif/omzet/tahun/dl?${this.query}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordTahunDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordTahunDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordTahunDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmCabangWeb(){
            if(this.input.bulanCabang == null || this.input.tahunCabang == null){
                this.$helper.toastErr(this, "Mohon isi periode laporan!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanCabang)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openCabangWeb()
                    this.input.passwordCabangWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-cabang-webPassword')
                }
            }
        },

        openCabangWeb(){
            this.showWebBulan = false
            this.showWebTahun = false
            this.showWebCabang = true
            this.isLoading = true
            this.$bvModal.hide('modal-cabang-search')
            this.$bvModal.hide('modal-cabang-webPassword')
            setTimeout(() => { this.axiosCabangWeb() }, 500)
        },

        axiosCabangWeb(){
            this.query = `bulan=${this.input.bulanCabang}&tahun=${this.input.tahunCabang}&tipe=${this.input.tipePinjamanCabang}&password=${this.input.passwordCabangWeb}`
            this.$axios.get(`laporan-eksekutif/omzet/cabang?${this.query}`).then(response => {
                this.showDataOmzetAll = response.data
                this.showDataOmzet = response.data.entries
                this.isLoading = false
                this.isBusy = false
                console.log(response.data)
                let idx = this.optionBulan.findIndex(item => item.value == this.input.bulanCabang)
                this.periodeBulan = this.optionBulan[idx].text
                this.periodeTahun = this.input.tahunCabang
                let idxTipeLaporan= this.tipePinjamanOption.findIndex(item => item.value == this.input.tipePinjamanCabang)
                this.jenisTipeLaporan = this.tipePinjamanOption[idxTipeLaporan].text
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordCabangWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordCabangWeb = ""
                this.updateTotalItem()
                this.perPage = 10
                this.currentPage = 1
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordCabangWeb = ""
                this.showWebBulan = false
                this.showWebTahun = false
                this.showWebCabang = false
                this.isLoading = false
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmCabangDownload(){
            if(this.input.bulanCabang == null || this.input.tahunCabang == null){
                this.$helper.toastErr(this, "Mohon isi periode laporan!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanCabang)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openCabangDownload()
                    this.input.passwordCabangDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-cabang-downloadPassword')
                }
            }
        },

        openCabangDownload(){
            this.showWebBulan = false
            this.showWebTahun = false
            this.showWebCabang = false
            this.isLoading = true
            this.$bvModal.hide('modal-cabang-search')
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-cabang-downloadPassword')
            setTimeout(() => { this.axiosCabangDownload() }, 500)
        },
        
        axiosCabangDownload(){
            this.query = `bulan=${this.input.bulanCabang}&tahun=${this.input.tahunCabang}&tipe=${this.input.tipePinjamanCabang}&password=${this.input.passwordCabangDownload}`
            this.$axios.get(`laporan-eksekutif/omzet/cabang/dl?${this.query}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordCabangDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordCabangDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordCabangDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataOmzet(){
            this.showDataOmzet = this.showDataOmzetAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Aksi baris filter -----------------

        // Periode & tipe pinjaman diproses server, jadi Search mengambil ulang data.
        // Password diminta sekali, setelahnya dipakai ulang dari localStorage.
        onSearch(){
            this.confirmCabangWeb()
        },

        onResetAll(){
            this.onReset()
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataOmzet()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.showDataOmzetAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.showDataOmzet = filteredArray
                this.onFiltered(this.showDataOmzet)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.showDataOmzet.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

    },

    created(){
        this.init()
    }
}
</script>


<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-hover: #0A5247;
$brass: #C69B6B;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

.lapeks-page { padding-bottom: 30px; }

.filter-card,
.table-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.filter-card { padding: 22px 24px 24px; }
.table-card  { padding: 0; overflow: hidden; margin-bottom: 16px; }

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

// Label varian laporan di dalam kartu tabel
.table-card-label {
    position: relative;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-heading;
    padding: 18px 20px 12px 32px;
    margin: 0;
    border-bottom: 1px solid #EDF2EF;

    &::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 19px;
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background-color: $brass;
    }
}

// Filter
.filter-section {
    .filter-controls-row {
        display: flex;
        align-items: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    .filter-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .filter-sublabel {
        font-size: 11.5px;
        font-weight: 600;
        color: $ink-body;
    }

    .range-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .range-sep { font-size: 12px; color: $ink-muted; flex-shrink: 0; }

    ::v-deep .filter-input,
    .filter-select {
        height: 38px;
        border-radius: 8px;
        border: 1px solid $input-border;
        font-size: 13px;
        color: $ink-body;
        padding: 6px 14px;
        background-color: #FFFFFF;

        &::placeholder { color: #8C9F98; font-size: 12.5px; }

        &:focus {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            outline: none;
        }
    }

    ::v-deep .filter-input.input-days { width: 110px; }
    .filter-select { padding: 6px 12px; width: 180px; max-width: 100%; }

    .filter-multiselect-wrapper {
        width: 220px;
        max-width: 100%;

        ::v-deep .multiselect {
            min-height: 38px;

            .multiselect__tags {
                min-height: 38px;
                height: 38px;
                padding: 6px 30px 0 12px;
                border-radius: 8px;
                border: 1px solid $input-border;
                background: #FFFFFF;
                font-size: 13px;
                color: $ink-body;
            }

            .multiselect__placeholder {
                margin-bottom: 0;
                padding-top: 2px;
                color: #8C9F98;
                font-size: 12.5px;
            }

            .multiselect__single {
                margin-bottom: 0;
                padding-top: 2px;
                font-size: 13px;
                color: $ink-body;
                line-height: 20px;
            }

            .multiselect__select { height: 36px; width: 32px; padding: 4px 6px; }

            &.multiselect--active .multiselect__tags {
                border-color: $deep-pine;
                box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            }
        }
    }
}

.btn-filter-search {
    width: 40px;
    height: 38px;
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: $deep-pine-hover; border-color: $deep-pine-hover; }
    &:disabled { opacity: 0.7; cursor: not-allowed; }
}

.btn-filter-reset {
    height: 38px;
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    font-size: 12.5px;
    font-weight: 500;
    padding: 6px 18px;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
}

.table-responsive-wrapper { overflow-x: auto; }

.custom-data-table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;

    ::v-deep thead th {
        background-color: #F6F7F6;
        border-top: none;
        border-bottom: 1px solid #ECEFEC;
        font-size: 11px;
        font-weight: 600;
        color: #7E918B;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 14px 20px;
        vertical-align: middle;
        white-space: nowrap;
    }

    ::v-deep tbody tr {
        transition: background-color 0.15s ease;

        &:hover { background-color: #F8FAF9; }

        td {
            padding: 16px 20px;
            border-top: 1px solid #EDF2EF;
            border-bottom: none;
            vertical-align: middle;
            font-size: 13px;
            color: $ink-body;
            font-weight: 500;
        }

        &:first-child td { border-top: none; }
    }
}

.table-pagination-footer {
    border-top: 1px solid #EDF2EF;
    padding: 16px 20px 4px;

    .limit-label { font-size: 12.5px; color: $ink-muted; }

    .limit-select {
        height: 32px;
        width: 70px;
        border-radius: 6px;
        border: 1px solid $input-border;
        font-size: 12.5px;
        color: $ink-body;
        padding: 2px 8px;
        background-color: #FFFFFF;
    }

    .entries-info { font-size: 12px; color: $ink-muted; }
}

.custom-pagination {
    ::v-deep .page-item {
        margin: 0 2px;

        .page-link {
            border-radius: 6px !important;
            border: 1px solid $input-border;
            color: $ink-body;
            font-size: 12px;
            font-weight: 500;
            min-width: 32px;
            height: 32px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #FFFFFF;
            box-shadow: none !important;

            &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
        }

        &.active .page-link {
            background-color: $deep-pine !important;
            border-color: $deep-pine !important;
            color: #FFFFFF !important;
            font-weight: 700;
        }

        &.disabled .page-link {
            opacity: 0.45;
            background-color: #FAFCFA;
            border-color: #E2E7E3;
            color: #A0B0AA;
            cursor: not-allowed;
        }
    }
}

// Tombol Back pada halaman laporan cetak
.btn-back {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 600;
    padding: 7px 16px;
    transition: all 0.2s ease;

    &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
}
</style>
